<template>
    <div>
        <BackButton />

        <div class="inner-content left">
            <h1>{{$t('client_mail_result.title')}}</h1>

            <div class="email-form">
                <input class="field-email inputfield" :class="{error:emailError}"  type="email" v-model="email" :placeholder="$t('generic.email')" />

                <button class="btn-basic bordered btn-email" type="button" @click.prevent="submitEmail">
                    {{$t('generic.send')}}
                </button>

                <div class="result--feedback" v-if="feedback">
                    {{$t('client_mail_result.feedback')}}
                </div>
                <div class="result--error" v-if="error">
                    {{$t('client_mail_result.error')}}
                </div>
            </div>
        </div>

        <Loading v-if="loading" />
    </div>
</template>

<script>
import BackButton from "@/components/app/BackButton.vue";
import Loading from "@/components/app/Loading.vue";
import {apiStore} from "@/stores/api";
import {isValidEmail} from "@/utils/utils.js";

export default {
    name : "ClientEmailDetail",
    components : {
        BackButton,
        Loading
    },

    data() {
        return {
            email: "",
            emailError : false,
            loading : false,
            ergosleep_id : null,
            feedback : false,
            error : false
        };
    },

    async created() {
        this.ergosleep_id = this.$route.params.ergosleep_id;

        try {
            const result = await apiStore().getErgosleepUserById(this.ergosleep_id);

            if (result.client !== null) {
                this.email = result.client.email;
            }
        } catch (error) {
            console.error("getErgosleepUserById error:", error);
        }
    },

    methods: {
        async submitEmail() {
            this.feedback = false;
            this.error = false;

            if (!isValidEmail(this.email)) {
                this.emailError = true;

            } else {
                this.emailError = false;
                this.loading = true;

                try {
                    const result = await apiStore().mailMeasurementResultToClient(this.ergosleep_id, this.email, this.$i18n.locale);

                    if (result.result === "ok") {
                        this.feedback = true;
                        this.error = false;
                    } else {
                        this.feedback = false;
                        this.error = true;
                    }

                } catch (error) {
                    console.error("mailMeasurementResultToClient error:", error);
                    this.error = true;
                }

                this.loading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .field-email {
        width : 50%;
        @include slideIntroAnimation(basicSlideIntro, 450ms, 250ms);
    }

    .btn-email {
        display:block;
        @include slideIntroAnimation(basicSlideIntro, 450ms, 650ms);
    }

    .email-form {
        margin-top : 1rem;
    }

    .result--feedback {
        color : $color-green;
        font-size: 1.2em;
        margin-top : 1.2rem;
    }

    .result--error {
        color : $color-red;
        font-size: 1.2em;
        margin-top : 1.2rem;
    }

</style>